import { Link } from "react-router-dom";
import { ArrowLeft, Construction, Phone, MapPin, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BRAND_COLORS } from "@/lib/menuData";
import Footer from "@/components/Footer";

export default function Contact() {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: BRAND_COLORS.sandWhite }}>
      {/* Header */}
      <header className="py-4 px-6" style={{ backgroundColor: BRAND_COLORS.deepTeal }}>
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/">
            <Button variant="ghost" size="sm" className="text-white hover:bg-white/10">
              <ArrowLeft className="h-4 w-4 mr-2" /> Back to Home
            </Button>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 py-16 px-6">
        <div className="max-w-lg mx-auto">
          <div className="text-center mb-8">
            <div 
              className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center"
              style={{ backgroundColor: BRAND_COLORS.tropicalAqua + "20" }}
            >
              <Construction className="h-10 w-10" style={{ color: BRAND_COLORS.tropicalAqua }} />
            </div>
            
            <h1 className="text-2xl font-bold mb-4" style={{ fontFamily: "Montserrat", color: BRAND_COLORS.darkSlate }}>
              Contact Us
            </h1>
            
            <p className="text-gray-600">
              Contact form coming soon. In the meantime, reach us directly:
            </p>
          </div>
          
          {/* Contact Info Cards */}
          <div className="space-y-4">
            <a 
              href="tel:+12518612320"
              className="flex items-center gap-4 p-4 bg-white rounded-xl border border-slate-100 hover:border-slate-200 transition-colors"
            >
              <div 
                className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: BRAND_COLORS.sunsetOrange + "20" }}
              >
                <Phone className="h-5 w-5" style={{ color: BRAND_COLORS.sunsetOrange }} />
              </div>
              <div>
                <p className="font-semibold" style={{ color: BRAND_COLORS.darkSlate }}>Call Us</p>
                <p className="text-sm text-gray-600">(251) 861-2320</p>
              </div>
            </a>
            
            <a 
              href="https://maps.google.com/?q=1000+Bienville+Blvd+Dauphin+Island+AL+36528"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-4 p-4 bg-white rounded-xl border border-slate-100 hover:border-slate-200 transition-colors"
            >
              <div 
                className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: BRAND_COLORS.deepTeal + "20" }}
              >
                <MapPin className="h-5 w-5" style={{ color: BRAND_COLORS.deepTeal }} />
              </div>
              <div>
                <p className="font-semibold" style={{ color: BRAND_COLORS.darkSlate }}>Visit Us</p>
                <p className="text-sm text-gray-600">1000 Bienville Blvd, Dauphin Island, AL 36528</p>
              </div>
            </a>
          </div>
          
          <div className="mt-8 text-center">
            <Link to="/">
              <Button 
                variant="outline" 
                className="rounded-xl"
                style={{ borderColor: BRAND_COLORS.deepTeal, color: BRAND_COLORS.deepTeal }}
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to Home
              </Button>
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
